import { TextField } from '@mui/material';

const fieldSx = {
  backgroundColor: "rgba(255,255,255,0.08)",
  borderRadius: "8px",
  "& .MuiInputBase-input": { color: "#fff" },
  "& .MuiInputBase-input::placeholder": { color: "rgba(255,255,255,0.4)", opacity: 1 },
  "& .MuiOutlinedInput-root": {
    "& fieldset": { borderColor: "rgba(255,255,255,0.3)" },
    "&:hover fieldset": { borderColor: "rgba(255,255,255,0.6)" },
    "&.Mui-focused fieldset": { borderColor: "#00ff88" },
  },
  "& .MuiInputLabel-root": { color: "rgba(255,255,255,0.6)" },
  "& .MuiInputLabel-root.Mui-focused": { color: "#00ff88" },
  "& .MuiFormHelperText-root": { color: "#ff6b6b" },
};

const CustomTextField = ({
  name,
  label,
  value,
  onChange,
  register,
  errors,
  validation = {},
  type = 'text',
  multiline = false,
  rows,
  required = false,
  InputProps = {},
  ...props
}) => {
  const commonProps = {
    label,
    type,
    fullWidth: true,
    multiline,
    rows: multiline ? rows : undefined,
    error: !!errors?.[name],
    helperText: errors?.[name]?.message || '',
    required,
    sx: { ...fieldSx, ...(props.sx || {}) },
    InputProps: {
      ...InputProps,
      sx: { ...(InputProps?.sx || {}) },
    },
    InputLabelProps: {
      ...props.InputLabelProps,
      sx: {
        "& .MuiFormLabel-asterisk": { color: "#ff6b6b" },
        ...(props.InputLabelProps?.sx || {}),
      },
    },
    ...props,
  };

  if (register) {
    return <TextField {...commonProps} {...register(name, validation)} />;
  }

  return <TextField {...commonProps} value={value} onChange={onChange} />;
};

export default CustomTextField;
